<template>
  <div>
    <b-row class="my-1">
      <b-col sm="2"><label :for="dbfield+'_input'">{{metadata.label}}:</label></b-col>
      <b-col sm="10">
        <b-form-group label="¿existe en el registro?">
          <b-form-checkbox-group :id="dbfield+'_input'" v-model="svalue" :name="dbfield+'_input'"
                                  :plaintext="read_only">
            <b-form-checkbox value="si">Si</b-form-checkbox>
            <b-form-checkbox value="no">No</b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FormComponentBase from './FormComponentBase'

export default {
  name: 'FormComponentExists',
  extends: FormComponentBase,
  /* components: {
    FormComponent: () => import('./FormComponent')
  }, */
  data () {
    return {
      svalue: null
    }
  },
  mounted () {
    if (this.value) {
      this.svalue = this.value
    }
  },
  watch: {
    value: function (val) {
      this.$set(this, 'svalue', val)
      this.$emit('valuechange', val)
    },
    svalue: function (val) {
      this.$emit('input', val)
    }
  },
  computed: {
    read_only: function () {
      var readOnly = false
      if (this.metadata.read_only) readOnly = true
      if (this.metadata.edit_roles) {
        if (!this.user) return true
        for (var i in this.metadata.edit_roles) {
          if ((this.user.roles.indexOf('_admin') !== -1) ||
            (this.user.roles.indexOf(this.metadata.edit_roles[i]) !== -1)) {
            return readOnly
          }
        }
        return true
      } else {
        return readOnly
      }
    }
  }
}
</script>

<style>
.custom-control-label {
    position: relative;
    padding-left: 22px;
}

</style>
